import { c as _c } from "react/compiler-runtime";
import { PaymentMethods } from 'api-graphql-types/enums';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import useNativePaymentMethodsAreAvailable from '../useNativePaymentMethodsAreAvailable';
import usePaymentMethodsToRender from '../usePaymentMethodsToRender';
import { useDonationFormValues } from '@/donationPages/_dependencies/helpers';
const DEFAULT_PAYMENT_METHOD_PRIORITY = [PaymentMethods.Paypal, PaymentMethods.StripeApplePay, PaymentMethods.StripeGooglePay, PaymentMethods.StripeSepaDebit];
function useSelectDefaultPaymentMethod() {
  const $ = _c(12);
  const {
    paymentMethodsToRender,
    nativePaymentsLoading
  } = usePaymentMethodsToRender();
  const shouldUseNativePaymentMethods = useNativePaymentMethodsAreAvailable();
  const {
    setValue
  } = useFormContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["payment_method"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [selectedPaymentMethod] = useDonationFormValues(t0);
  let t1;
  if ($[1] !== nativePaymentsLoading || $[2] !== paymentMethodsToRender || $[3] !== selectedPaymentMethod || $[4] !== setValue) {
    t1 = () => {
      if (nativePaymentsLoading) {
        return;
      }
      if (paymentMethodsToRender.includes(selectedPaymentMethod)) {
        return;
      }
      const preferred = DEFAULT_PAYMENT_METHOD_PRIORITY.find(value => paymentMethodsToRender.includes(value)) || selectedPaymentMethod;
      if (selectedPaymentMethod === preferred) {
        return;
      }
      setValue("_default_payment_method", preferred);
      setValue("payment_method", preferred);
    };
    $[1] = nativePaymentsLoading;
    $[2] = paymentMethodsToRender;
    $[3] = selectedPaymentMethod;
    $[4] = setValue;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== nativePaymentsLoading || $[7] !== paymentMethodsToRender || $[8] !== selectedPaymentMethod || $[9] !== setValue || $[10] !== shouldUseNativePaymentMethods) {
    t2 = [paymentMethodsToRender, selectedPaymentMethod, setValue, nativePaymentsLoading, shouldUseNativePaymentMethods];
    $[6] = nativePaymentsLoading;
    $[7] = paymentMethodsToRender;
    $[8] = selectedPaymentMethod;
    $[9] = setValue;
    $[10] = shouldUseNativePaymentMethods;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  useEffect(t1, t2);
}
export default useSelectDefaultPaymentMethod;